import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { SpeedInsights } from "@vercel/speed-insights/react";

import LandingPage from "./pages/LandingPage";
import { ThemeProvider } from "./components/theme-provider";
import { Toaster } from "./components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HealthPing = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      // Keeping this ping for environment sanity; website is frontend-first.
      console.log("Backend:", response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting /api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return null;
};

function App() {
  return (
    <ThemeProvider>
      <HealthPing />
      <Toaster richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <SpeedInsights />
    </ThemeProvider>
  );
}

export default App;
